import pulse from "@finn-no/pulse-sdk";

export const trackView = (name: string) => {
	return pulse.trackPageView({
		type: "View",
		name,
		object: {
			type: "Page",
			name: "Company Profile",
		},
		vertical: {
			name: "business_center",
			subVertical: "job",
		},
	});
};
